import styled from 'styled-components';

import { Text } from '@dreryk/react-components';

export const StyledNewsCardListElementLinkNotFound = styled(Text)`
   color: ${(props) => props.theme.border};
`;
StyledNewsCardListElementLinkNotFound.displayName = 'StyledNewsCardListElementLinkNotFound';
